module.exports = __webpack_public_path__ + "img/defaultUser.c0109d44.png";